import React from 'react'
import AllRoutes from './Components/AllRoutes/AllRoutes'
import Header from './Components/Header/Header'

const App = () => {
  return (
    <div>
      <Header />
      <AllRoutes />
    </div>
  )
}

export default App